import { gql } from "@apollo/client";
import { productListingAllFieldsFragment } from "./CommonQueries";
import { ProductListing } from "../../../common/models";
import {
    BaseQueryResult,
    useBaseQuery
} from "./index";

const productListingQuery = gql`
    ${productListingAllFieldsFragment}
    query productListing($id: String!) {
        productListing(id: $id) {
            ...ProductListingAllFields
        }
    }
`;

export const useProductListingQuery = (id: string): BaseQueryResult<ProductListing> => {
    return useBaseQuery<ProductListing, { productListing: ProductListing }>(
        productListingQuery,
        {id},
        ({data}) => data.productListing,
    );
};
